import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { selectPortalCustomerContact, portalLogout } from "../../../../store/slice/portalAuthSlice";
import {
  StyledAccountPopupContainer,
  StyledUserInfoSection,
  StyledProfileAvatar,
  StyledUserDetails,
  StyledSeparator,
  StyledActionList,
} from "./PortalAccountPopup.styles";

export const PortalAccountPopup = ({ styleOfModal, closeModal }) => {
  const { subdomain } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modalRef = useRef(null);

  const customerContact = useSelector(state => selectPortalCustomerContact(state, subdomain));

  const handleClickOutside = event => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [closeModal]);

  const handleLogout = () => {
    dispatch(portalLogout({ subdomain }));
    navigate(`/portal/${subdomain}/auth/login`);
  };

  const firstName = customerContact?.first_name || "";
  const lastName = customerContact?.last_name || "";
  const email = customerContact?.email || "";
  const fullName = `${firstName} ${lastName}`.trim() || "User";
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || "U";

  return (
    <div style={styleOfModal} ref={modalRef}>
      <StyledAccountPopupContainer>
        <StyledUserInfoSection>
          <StyledProfileAvatar>{initials}</StyledProfileAvatar>
          <StyledUserDetails>
            <div className="name" title={fullName}>
              {fullName}
            </div>
            <div className="email" title={email}>
              {email}
            </div>
          </StyledUserDetails>
        </StyledUserInfoSection>

        <StyledSeparator />

        <StyledActionList>
          <button className="action-item" onClick={handleLogout}>
            Sign out
          </button>
        </StyledActionList>
      </StyledAccountPopupContainer>
    </div>
  );
};
